import PropTypes from "prop-types"

export const MImage = PropTypes.shape({
  characterestic_code: PropTypes.string,
  description: PropTypes.string.isRequired,
  hd_size_image_url: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  image_type_code: PropTypes.string.isRequired,
  medium_size_image_url: PropTypes.string.isRequired,
  order: PropTypes.number.isRequired,
  original_size_image_url: PropTypes.string.isRequired,
  room_code: PropTypes.string,
  room_type: PropTypes.string,
  small_size_image_url: PropTypes.string.isRequired,
  standard_size_image_url: PropTypes.string.isRequired,
})
